export function activationTokenFromHash(hash) {
  if (!hash?.startsWith("#")) return null

  const token = new URLSearchParams(hash.slice(1)).get("token")?.trim()
  return token || null
}

export function locationWithoutHash(location) {
  return `${location.pathname}${location.search}`
}
